module.exports = __webpack_public_path__ + "img/starface_up_logo.7a86cbc0.png";